import api from "./axios";

export const getPobScore = () => api.get("/pobscoredefault");

export const getPobScoreByDateRange = (a, b) =>
    api.post("/pobscore-test", {
        FromDate: a,
        ToDate: b,
    });
